<template>
  <section class="about-content">
    <h1>{{ctfName}}</h1>
    <hr/>
    <VueMarkdown :source="contestInfo"></VueMarkdown>
  </section>
</template>

<script>
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import i18n from '@/i18n'
  import VueMarkdown from 'vue-markdown'

  const data = `比赛信息`

  export default {
    data () {
      return {
        source: data,
        frameId: 0
      }
    },
    computed: {
      ...mapState(['name', 'v_locale', 'contestInfo', 'ctfName', 'theme', 'endTime', 'startTime']),
      ...mapGetters(['gameOver']),
      ...i18n.map([
        'competitionInfo_', 'competitionTime_', 'contact_',
        'prize_', 'categories_', 'rules_', 'organizer_',
        'sponsors_', 'media_'
      ])
    },
    components: {
      VueMarkdown
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([])
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/home.vue